import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { routes } from './routes';

const Router: React.FC = () => <Switch>{routes.map(x => <Route key={x.name} path={x.path} component={x.component} exact={x.exact}/>)}</Switch>

export default Router;